"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
require("./MediaViewer.scss");
var _types = require("../../utils/types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MediaViewer = function MediaViewer(_ref) {
  var show = _ref.show,
    toggle = _ref.toggle,
    multimediaFiles = _ref.multimediaFiles,
    index = _ref.index,
    withFooter = _ref.withFooter;
  var _useTranslation = (0, _reactI18next.useTranslation)(['media-viewer']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipDownload = _useState2[0],
    setTooltipDownload = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipBack = _useState4[0],
    setTooltipBack = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeFile = _useState6[0],
    setActiveFile = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    multimedia = _useState8[0],
    setMultimedia = _useState8[1];
  var aRef = (0, _react.useRef)(null);
  var download = function download() {
    aRef.current.click();
  };
  (0, _react.useEffect)(function () {
    return function () {
      setTooltipBack(false);
    };
  }, [show]);
  (0, _react.useEffect)(function () {
    setActiveFile(index ? index : 0);
  }, [index]);
  (0, _react.useEffect)(function () {
    if (multimediaFiles.length > 0) {
      var arr = multimediaFiles.map(function (file) {
        return {
          media: file.url,
          mediaType: file.mediaType,
          mediaName: splitName(file.url)
        };
      });
      setMultimedia(arr);
    }
  }, [multimediaFiles]);
  var splitName = function splitName(url) {
    if (url.indexOf('\\') > -1) {
      var temp = url.split('\\');
      return temp[temp.length - 1];
    } else {
      var _temp = url.split('/');
      return _temp[_temp.length - 1];
    }
  };
  var slide = function slide(direction) {
    setActiveFile(direction === 'left' ? activeFile - 1 : activeFile + 1);
  };
  var _ref2 = multimedia && multimedia[activeFile],
    media = _ref2.media,
    mediaType = _ref2.mediaType,
    mediaName = _ref2.mediaName;
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    className: "uin-media-viewer ".concat(withFooter ? 'withFooter' : ''),
    isOpen: show,
    toggle: toggle,
    centered: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    ref: aRef,
    href: media,
    download: mediaName,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: 'none'
    }
  }, mediaName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__back"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    id: "uin-mv-icon-back",
    className: "gcl-icon arrow",
    onClick: toggle
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
    placement: "bottom",
    isOpen: tooltipBack,
    target: "uin-mv-icon-back",
    toggle: function toggle() {
      return setTooltipBack(!tooltipBack);
    }
  }, t('back'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__name"
  }, mediaName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__download"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    id: "uin-mv-icon-download",
    className: "gcl-icon download",
    onClick: download
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
    placement: "bottom",
    isOpen: tooltipDownload,
    target: "uin-mv-icon-download",
    toggle: function toggle() {
      return setTooltipDownload(!tooltipDownload);
    }
  }, t('download')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__content ".concat(withFooter ? 'withFooter' : '')
  }, withFooter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-previus-miniature ".concat(activeFile === 0 && 'disabled')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-left",
    disabled: activeFile === 0,
    onClick: function onClick() {
      return slide('left');
    }
  })), media && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mediaType === 'image' && /*#__PURE__*/_react["default"].createElement("img", {
    src: media,
    alt: mediaName,
    onClick: download
  }), mediaType === 'video' && /*#__PURE__*/_react["default"].createElement("video", {
    preload: "auto",
    autoPlay: true,
    controls: true,
    src: media,
    onClick: download
  }), mediaType === 'audio' && /*#__PURE__*/_react["default"].createElement("audio", {
    preload: "auto",
    autoPlay: true,
    controls: true,
    src: media,
    onClick: download
  })), withFooter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-previus-miniature ".concat(activeFile === multimedia.length - 1 && 'disabled')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-right",
    disabled: activeFile === multimedia.length - 1,
    onClick: function onClick() {
      return slide('right');
    }
  }))), withFooter && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer__footer"
  }, multimedia && multimedia.map(function (v, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "uin-miniaturs ".concat(activeFile === i && 'active'),
      onClick: function onClick() {
        return setActiveFile(i);
      }
    }, v.mediaType === 'image' ? /*#__PURE__*/_react["default"].createElement("img", {
      src: v.media,
      alt: ""
    }) : v.mediaType === 'audio' ? /*#__PURE__*/_react["default"].createElement("audio", {
      src: v.media,
      preload: "metadata"
    }) : v.mediaType === 'video' ? /*#__PURE__*/_react["default"].createElement("video", {
      src: v.media,
      preload: "metadata"
    }) : /*#__PURE__*/_react["default"].createElement("div", null, "otro tipo"));
  })));
};
MediaViewer.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  multimediaFiles: _propTypes["default"].arrayOf(_types.arrayMultimedia).isRequired,
  index: _propTypes["default"].number,
  withFooter: _propTypes["default"].bool
};
MediaViewer.defaultProps = {
  withFooter: false
};
var _default = exports["default"] = MediaViewer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MediaViewer/MediaViewer.js
// module id = 378
// module chunks = 0